export default __webpack_public_path__ + "static/media/ic-close.68123170.svg";